/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 3/28/2019.
 */

import React from 'react'
import {injectIntl, FormattedMessage} from 'react-intl';
import {formatDateTime} from "../../common/LocaleHelper";
import {Button, Grid, Icon, TextArea} from '@scuf/common';

class CommentsTableRow extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            editing: false,
            text: this.props.comment.text,
            expanded: true,
        }

        this.toggleEdit = this.toggleEdit.bind(this)
        this.toggleExpand = this.toggleExpand.bind(this)
        this.handleCommentChange = this.handleCommentChange.bind(this)
        this.handleSaveComment = this.handleSaveComment.bind(this)
    }

    toggleEdit(e) {
        this.setState({editing: !this.state.editing, text: this.props.comment.text})
        e.stopPropagation()
    }

    toggleExpand() {
        if (!this.state.editing) {
            this.setState({expanded: !this.state.expanded})
        }
    }

    handleCommentChange(text) {
        this.setState({text: text})
    }

    handleSaveComment() {
        this.props.updateComment(this.props.comment.id, this.state.text, () => {
            this.setState({editing: false})
        })
    }

    formatText(text) {
        return text.split('\n').map((item, key) => {
            return <React.Fragment key={key}>{item}<br/></React.Fragment>
        })
    }

    render() {
        const {intl, comment} = this.props

        const canEditComment = !this.state.editing && this.props.updateComment && this.state.expanded
        let expandedContent = null
        let collapsedContent = null
        if (this.state.expanded) {
            expandedContent = <div className="history-item-content">{this.formatText(comment.text)}</div>
        } else {
            collapsedContent = <div className="history-item-content">{comment.text}</div>
        }
        return (
            <div className={"history-item " + (this.state.expanded ? 'expanded' : 'collapsed') + (this.state.editing ? ' editing' : '')}>
                <div className="history-item-header" onClick={this.toggleExpand}>
                    <FormattedMessage id="useranddate" values={{user: comment.userName, date: formatDateTime(comment.createDate)}} />
                    {
                        comment.modifyDate ?
                            <span className="edited-label" title={formatDateTime(comment.modifyDate)}>
                                <FormattedMessage id="fault.detail.comment.edited"/>
                            </span>
                            :
                            ''
                    }
                    {collapsedContent}
                    <div className="icons">
                        {
                            canEditComment ?
                                <Icon name="edit" size="medium" onClick={this.toggleEdit}/>
                                :
                                ''
                        }
                        <Icon className="expand-icon" name={this.state.expanded ? 'caret-up' : 'caret-down'} size="medium" onClick={this.toggleExpand}/>
                    </div>
                </div>
                {this.state.editing ?
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={12}>
                                <TextArea value={this.state.text} onChange={this.handleCommentChange}
                                          helperText={intl.formatMessage({id: "fault.detail.comment.warning"})} fluid/>
                            </Grid.Column>
                            <Grid.Column width={12}>
                                <div className="right">
                                    <Button content={intl.formatMessage({id: "fault.detail.button.cancel"})}
                                            onClick={this.toggleEdit} type="secondary"/>
                                    <Button content={intl.formatMessage({id: "fault.detail.button.save"})}
                                            onClick={this.handleSaveComment} type="primary"
                                            disabled={!this.state.text}/>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    :
                    expandedContent
                }
            </div>
        )
    }
}

export default injectIntl(CommentsTableRow)